/*
 * @Author: Jason
 * @Date: 2025-02-19 21:27:25
 * @LastEditors: Jason
 * @LastEditTime: 2025-07-22 18:00:42
 * @FilePath: /WebPlayer/src/shared/constants/fields.ts
 * @Description:
 *
 * Copyright (c) 2025 by meitrack, All Rights Reserved.
 */
// 字段常量
export const fields = {
    isDark: 'IS_DARK',
    locale: 'LOCALE',
    networkConfig: 'NETWORK_CONFIG',
    token: 'TOKEN',
    sssid: 'SSSID',
    playSettings: 'PLAY_SETTINGS',
    userInfo: 'USER_INFO', // 用户信息
};
